import React, { PureComponent } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
  {
    date: '7 Oct',
    Frigorifico: 20,
    Cisterna: 15,
    Trailer: 40,
    Camion: 30,
  },
  {
    date: '8 Oct',
    Frigorifico: 25,
    Cisterna: 20,
    Trailer: 15,
    Camion: 35,
  },
  {
    date: '9 Oct',
    Frigorifico: 22,
    Cisterna: 18,
    Trailer: 12,
    Camion: 28,
  },
  {
    date: '10 Oct',
    Frigorifico: 30,
    Cisterna: 25,
    Trailer: 20,
    Camion: 40,
  },
  {
    date: '11 Oct',
    Frigorifico: 18,
    Cisterna: 10,
    Trailer: 8,
    Camion: 22,
  },
  {
    date: '12 Oct',
    Frigorifico: 35,
    Cisterna: 28,
    Trailer: 18,
    Camion: 45,
  },
];

export default class HorizontalLineChart extends PureComponent {
  render() {
    return (
        <div className="mb-10 inline-table w-full justify-center bg-white shadow-[0px_5px_20px_rgba(0,0,0,0.3)] rounded-[16px] space-x-11">
            <div className="w-full p-6 ">
                <div className="flex items-center">
                    <p className="text-[20px] font-itcmedium text-[#007696] w-[50%]">
                        Porcentaje de cumplimiento
                    </p>
                    <div className='flex w-[50%] space-x-9 2xl:ml-[33rem]'>
                        <button className="sm:px-[10px]  px-[35px]  h-[46px] text-[14px] text-center bg-[#5CBDEB] border-2 text-[#52526C] rounded-[8px] font-itcmedium border-[#5CBDEB]">
                            Filtrar por empresa
                        </button> 
                        <button className="sm:px-[10px]  px-[35px]  w-[151px] h-[46px] text-[14px] text-center bg-white border-2 text-[#52526C] rounded-[8px] font-itcmedium border-[#5CBDEB]">
                            Filtrar por placa
                        </button> 
                    </div>   
                </div>
                <ResponsiveContainer width="100%" height={400}>
                    <LineChart
                        width={600}
                        height={400}
                        data={data}
                        margin={{
                            top: 20,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                        >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" type="category" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line dataKey="Frigorifico" stroke="#8884d8" />
                        <Line dataKey="Cisterna" stroke="#82ca9d" />
                        <Line dataKey="Trailer" stroke="#ffc658" />
                        <Line dataKey="Camion" stroke="#ff7300" />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>   
    );
  }
}
